/**
 * @generated SignedSource<<430123171b782bbb140819d62ff91395>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OverviewIndyEmptyState_organization$data = {
  readonly name: string;
  readonly " $fragmentType": "OverviewIndyEmptyState_organization";
};
export type OverviewIndyEmptyState_organization$key = {
  readonly " $data"?: OverviewIndyEmptyState_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"OverviewIndyEmptyState_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OverviewIndyEmptyState_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "85241000b5c154a7084b576a0f27e76c";

export default node;
